import { CheckIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

/** One selectable plan in the subscribe dialog. */
export const PlanRow = ({
  badge,
  caption,
  isSelected,
  onClick,
  price,
  priceUnit,
  title,
}: {
  badge?: React.ReactNode
  caption: string
  isSelected: boolean
  onClick(): void
  price: string
  /** "per år" / "per månad" / "engångsvis" — small and muted, trailing right behind the
   * price rather than matching its size, so the number itself is what stands out. */
  priceUnit: string
  title: string
}) => (
  <button
    className={cn(
      'relative flex items-start gap-3.5 rounded-xl border p-[18px_20px] text-left transition-colors',
      isSelected ? 'border-2 border-brand-funkia bg-brand-funkia/5' : 'hover:bg-brand-lime',
    )}
    onClick={onClick}
    type="button"
  >
    {badge && <span className="absolute right-3 top-3">{badge}</span>}
    <span
      className={cn(
        'mt-0.5 flex size-[22px] shrink-0 items-center justify-center rounded-full',
        isSelected ? 'bg-brand-funkia' : 'border border-border-strong-01',
      )}
    >
      {isSelected && <CheckIcon className="size-3.5 text-white" strokeWidth={3.4} />}
    </span>
    <span className="min-w-0 flex-1">
      <span className="font-heading text-[17px] font-bold text-brand-gran">{title}</span>
      {/* The cost is the thing that should stand out here — bigger and heavier than the
          title above it, which stays exactly as it was. */}
      <span className="mt-1 block font-heading text-[24px] font-black text-brand-gran">
        {price}
        <span className="ml-1 font-body text-[15px] font-semibold text-[#586574]">
          {priceUnit}
        </span>
      </span>
      <span className="mt-0.5 block text-[15px] text-[#586574]">{caption}</span>
    </span>
  </button>
)
